import { render } from "./TNovoGrupo.vue?vue&type=template&id=8d7738da&scoped=true"
const script = {}

import "./TNovoGrupo.vue?vue&type=style&index=0&id=8d7738da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d7738da"]])

export default __exports__